import LinkElement from "./LinkElement.vue";
import TextMarquee from "./TextMarquee.vue";
import ScribeTyping from "./ScribeTyping.vue";
import ScrollDown from "./ScrollDown.vue";
import ScrollTop from "./ScrollTop.vue";
import CookiesNotice from "./CookiesNotice.vue";
import QuotationForm from "./QuotationForm.vue";
import Testimonies from "./Testimonies.vue";
import Faq from "./Faq.vue";

export default {
    LinkElement,
    TextMarquee,
    ScribeTyping,
    CookiesNotice,
    ScrollDown,
    ScrollTop,
    QuotationForm,
    Testimonies,
    Faq,
};